<template>
  <aside ref="menu" class="modern-account-menu" role="dialog" aria-modal="false" aria-label="Centro de cuenta" @keydown="onKeydown">
    <header class="modern-account-menu__identity">
      <span class="modern-account-menu__avatar" aria-hidden="true">{{ identity.initials }}</span>
      <div>
        <strong>{{ identity.name }}</strong>
        <span v-if="identity.plan">Plan {{ identity.plan }}</span>
      </div>
    </header>

    <ModernNotificationsPreview :state="notificationState" @mark-read="$emit('mark-read')" />

    <section class="modern-account-menu__section" aria-label="Cuenta">
      <button type="button" @click="$emit('navigate', 'MyProfile')"><span aria-hidden="true">◎</span> Mi perfil</button>
      <button type="button" @click="$emit('navigate', 'Pricing')"><span aria-hidden="true">◇</span> Suscripción y planes</button>
    </section>

    <section class="modern-account-menu__section" aria-labelledby="modern-appearance-title">
      <h3 id="modern-appearance-title">Apariencia</h3>
      <div class="modern-account-menu__themes" role="radiogroup" aria-label="Tema">
        <button v-for="theme in themes" :key="theme.value" type="button" role="radio"
          :aria-checked="String(preferenceState.preferences.themeMode === theme.value)"
          :class="{ 'is-selected': preferenceState.preferences.themeMode === theme.value }"
          @click="$emit('theme', theme.value)">{{ theme.label }}</button>
      </div>
      <button v-if="fullscreenState.supported" type="button" @click="$emit('fullscreen')">
        <span aria-hidden="true">⛶</span> {{ fullscreenState.active ? 'Salir de pantalla completa' : 'Pantalla completa' }}
      </button>
      <button v-if="chatState.available" type="button" :disabled="chatState.status === 'loading'" @click="$emit('chat')">
        <span aria-hidden="true">◌</span> {{ chatState.status === 'loading' ? 'Abriendo chat…' : 'Abrir chat' }}
      </button>
      <button type="button" @click="$emit('classic')"><span aria-hidden="true">↶</span> Cambiar a la versión clásica</button>
      <p v-if="preferenceState.error" class="modern-account-menu__error" role="status">No se pudo guardar el cambio. Inténtalo de nuevo.</p>
      <p v-if="fullscreenState.error || chatState.error" class="modern-account-menu__error" role="status">La acción no está disponible ahora mismo.</p>
    </section>

    <section class="modern-account-menu__section modern-account-menu__session">
      <button type="button" @click="$emit('logout')"><span aria-hidden="true">→</span> Cerrar sesión</button>
    </section>
  </aside>
</template>

<script>
import ModernNotificationsPreview from '@/shells/modern/ModernNotificationsPreview.vue';

export default {
  name: 'ModernAccountMenu',
  components: { ModernNotificationsPreview },
  props: {
    identity: { type: Object, required: true },
    preferenceState: { type: Object, required: true },
    notificationState: { type: Object, required: true },
    fullscreenState: { type: Object, required: true },
    chatState: { type: Object, required: true }
  },
  data: () => ({ themes: [
    { value: 'light', label: 'Claro' },
    { value: 'dark', label: 'Oscuro' },
    { value: 'system', label: 'Automático' }
  ] }),
  mounted() {
    this.$nextTick(() => {
      const first = this.$refs.menu && this.$refs.menu.querySelector('button:not([disabled])');
      if (first) first.focus();
    });
  },
  methods: {
    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.$emit('close');
        return;
      }
      if (event.key !== 'Tab') return;
      const controls = Array.from(this.$refs.menu.querySelectorAll('button:not([disabled]), a[href]'));
      if (!controls.length) return;
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
  }
};
</script>
